export default __webpack_public_path__ + "static/media/power_1_color.880a90de.svg";